<section class="section" #screen id="mainGraph">
    <div class="shell shell--size-3">
        <br />
        <div class="row chart" id="chartSize">
            <div class="col">
                <!-- <div class="chart__head hidden-xs"> -->
                <div class="chart__head">
                    <div class="chart__head-content" style="line-height: 0%;">
                        <!-- <h6>eToro Analysis</h6> -->

                        <h6>Trade Executions</h6>

                        <!-- <h5>Cummulative Performance Gain as at 30 November 2023</h5> -->

                        <span style="font-size: x-small" *ngIf="mobile">UPDATED: {{lastDate}}</span><br />
                        <span style="font-size: small" *ngIf="!mobile">UPDATED: {{lastDate}}</span><br />
                        <!-- <span>Last Updated: {{updateRecent}}</span> -->
                    </div><!-- /.chart__head-content -->

                </div><!-- /.chart__head -->
            </div>
            <div *ngIf="!mobile" class="col-auto legendGrad legendShadow" id="legend">
                <div id="legendItems">
                    <div class="row margBottomLegend" style="display: none;">
                        <div class="col-auto">AGR - 2021 (Traded Gain)</div>
                        <div class="col" style="text-align: right;"><span id="tGain"><span *ngIf="gPos">+</span>{{tGain}}%</span> </div>
                    </div>
                    <div class="row margBottomLegend">
                        <div class="col-auto">AGR +/-</div>
                        <div class="col" style="text-align: right;">
                            <span id="unrealised" *ngIf="agr >= 0" style="color: green">+{{agr}}%</span>
                            <span id="unrealised" *ngIf="agr < 0" style="color: red">{{agr}}%</span>
                        </div>
                    </div>
                    <div class="row margBottomLegend">
                        <div class="col-auto">Net Asset Value +/-</div>
                        <div class="col-auto" style="text-align: right;"><span id="netasset"><span
                                    *ngIf="netAssetPos">+</span>{{netAsset}}%</span></div>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="mobile" class="row legendGrad legendShadow" id="legend">
            <div id="legendItems">
                <div class="row margBottomLegend" style="display: none;">
                    <div class="col">AGR - 2021 (Traded Gain)</div>
                    <div class="col-auto legendPadMob"><span id="tGain"><span
                                *ngIf="gPos">+</span>{{tGain}}%</span> </div>
                </div>
                <div class="row margBottomLegend">
                    <div class="col">AGR +/- (Since Oct 2022)</div>
                    <div class="col">
                        <span id="unrealised" *ngIf="agr >= 0" style="color: green">+{{agr}}%</span>
                        <span id="unrealised" *ngIf="agr < 0" style="color: red">{{agr}}%</span>
                    </div>
                </div>
                <div class="row margBottomLegend">
                    <div class="col">Net Asset Value +/- (Since Launch)</div>
                    <div class="col-auto legendPadMob"><span id="netasset"><span
                                *ngIf="netAssetPos">+</span>{{netAsset}}%</span></div>
                </div>
            </div>
        </div>
        <br />
        <div class="row chart">
            <div class="chart__body" class="wow fadeInRight" data-wow-delay=".5s" id="chart">
                <div id="exeContainer" class="textCenter" style="height: 70vh">
                </div><!-- /.chart__body -->
            </div>
        </div>
    </div><!-- /.shell -->
</section>